/**
 * /dashboard/hiring — Hiring hub, Pipeline (a.k.a. Requisitions) view
 * (Phase 3d — 2026-06-01).
 *
 * Migration note: port of
 * frontend/src/app/(dashboard)/dashboard/hiring/page.tsx flattened with
 * the old `layout.tsx` into one route that uses HiringModuleShell.
 */

import { createFileRoute } from "@tanstack/react-router";
import { HiringModuleShell } from "@/components/shared/hiring-module-shell";
import { HiringFeatureGate } from "@/components/hiring/hiring-feature-gate";
import { RequisitionsTab } from "@/components/hiring/requisitions-tab";
import { isHiringHrAdmin } from "@/components/hiring/hr-admin-gate";
import { useAuth } from "@/lib/auth";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/hiring/")({
  component: HiringHubRoute,
});

function HiringHubRoute() {
  const { user } = useAuth();
  const isAdmin = isHiringHrAdmin(user?.role);
  return (
    <HiringModuleShell
      title="Hiring"
      description={
        isAdmin
          ? "Track open roles, candidates and interviews end to end."
          : "Your interviews and the roles you're hiring for."
      }
    >
      <HiringFeatureGate>
        <RequisitionsTab />
      </HiringFeatureGate>
    </HiringModuleShell>
  );
}
